import Modal from "../../common/atoms/modal";
import React, {useState} from "react";
import {FormGroup, FormLabel} from "../../common/atoms/formElements";
import Button from "../../common/atoms/button";
import CustomInput from "../../common/components/CustomInput";
import Utility from "../../utility";
import subscriptionPlans from "../../services/referralList";

const AddReferralUserModal = ({isVisible, setVisible, refreshList}) => {
    const [referralUserFormData, setFormData] = useState({})
    const handleChange = (e) => {
        const {id, checked, type, value} = e.target;
        if (id === "isDiscountedPromo") {
            setFormData((prevPlan) => ({...prevPlan, [id]: checked}));
        } else
            setFormData((prevPlan) => ({...prevPlan, [id]: value}));
    };

    const onAddUser = async (e) => {
        e.preventDefault();

        const planData = {
            name: referralUserFormData.name,
            description: referralUserFormData.description,
            code: referralUserFormData.code,
            isDiscountedPromo: referralUserFormData.isDiscountedPromo,

        };
        let [err, planAddSuccess] = await Utility.parseResponse(subscriptionPlans.addReferral(planData));
        if (!planAddSuccess || err) {
            return Utility.apiFailureToast(err || "Unable to add user");
        }

        refreshList();
        onModalClose();
    };

    const onModalClose = () => {
        setVisible(false)
    }

    return (
        <Modal isVisible={isVisible} onClose={onModalClose} title={'Add Referral User'}>
            <FormGroup>
                <div style={{
                    display: "flex",
                    justifyContent: "space-between",
                    flexDirection: "row",
                    alignItems: "start",
                    gap: "20px",
                    width: "100%",
                }}>
                    <div style={{
                        display: "flex",
                        flexDirection: "column",
                        flexGrow: 1,
                        gap: "5px",
                        alignItems: "start",
                        width: '50%',
                    }}>
                        <FormLabel isMandatory={true} label='User Name'/>
                        <CustomInput id='name' onChange={handleChange}/>
                        <FormLabel isMandatory={true} label='His/Her Promo code'/>
                        <CustomInput id='code' onChange={handleChange}/>
                        <FormLabel isMandatory={false} label='Note/Description (For internal purpose only)'/>
                        <CustomInput id='description' onChange={handleChange}/>
                        <div style={{display: "flex", gap: "5px", marginTop: "20px"}}>
                            <input id={"isDiscountedPromo"} type={"checkbox"} onChange={handleChange}/>
                            <FormLabel label='Discounted promo (Works for 499₹ plan only'/>
                        </div>

                    </div>
                </div>
                <br/>
                <Button onClick={onAddUser}>Add user</Button>
            </FormGroup>
        </Modal>
    )
}
export default AddReferralUserModal
